/** Labels aligned with teacher Attendance / schedule screens. */
export function formatLectureScheduleStatus(status) {
  switch (String(status || "").toUpperCase()) {
    case "COMPLETED":
      return "Completed";
    case "ATTENDANCE_MARKED":
      return "Attendance Marked";
    case "ATTENDANCE_MARKED_MANUAL":
      return "Attendance Marked (Manual)";
    case "NOT_TAKEN":
      return "Attendance Not Taken";
    case "RUNNING":
      return "Running";
    case "SESSION_NOT_STARTED":
      return "Attendance Not Taken";
    case "ATTENDANCE_NOT_MARKED":
      return "Attendance Not Marked";
    case "UPCOMING":
      return "Upcoming";
    default:
      return status || "Upcoming";
  }
}

/** True only after "Start attendance" — not the same as event window RUNNING. */
export function isSpecialSessionAttendanceRunning(row) {
  return row?.attendanceStarted === true;
}
